const fr = {
  nav: {
    home: "Accueil",
    songs: "Comptines",
    dodo: "Mode dodo",
    coloring: "Coloriages",
    sky: "Ciel de Bini",
    parents: "Espace parents",
    subscribe: "S'abonner à la chaîne",
    back: "Retour",
  },
  home: {
    hello: "Coucou, c'est Bini !",
    today: "Aujourd'hui, on chante :",
    play: "On chante !",
    karaoke: "Karaoké",
    coloringToday: "Le coloriage du jour",
  },
  songs: {
    title: "Comptines",
    allThemes: "Tous",
    allLangs: "Toutes",
    empty: "Oh ! Pas de comptine ici… Essaie un autre choix !",
    lyrics: "Paroles",
    noLyrics: "Les paroles arrivent bientôt !",
    coloring: "Coloriages",
    noColoring: "Bientôt des coloriages à imprimer !",
    ended: "Bravo ! On la rechante ?",
    replay: "Encore !",
  },
  lang: { fr: "Français", en: "English" },
  karaoke: {
    title: "Karaoké",
    auto: "Défilement auto",
    manual: "Manuel",
    speed: "Vitesse",
    slow: "Lent",
    fast: "Rapide",
    prev: "Ligne précédente",
    next: "Ligne suivante",
    restart: "Recommencer",
    play: "Lecture",
    pause: "Pause",
    mute: "Couper le son",
    unmute: "Remettre le son",
    volume: "Volume",
    noMusic: "Musique bientôt disponible",
  },
  dodo: {
    title: "Mode dodo",
    hint: "Choisis une douce comptine…",
    timer: "Arrêt après",
    minutes: "{n} min",
    stopsAt: "La musique s'arrêtera vers {time}",
    goodnight: "Bonne nuit…",
    goodnightBubble: "Bonne nuit, petit cœur…",
    hum: "Mmm mmm… Bini fredonne tout doucement.",
    goodnightSub: "Bini fait dodo. À demain !",
    again: "Rallumer",
    empty: "Pas encore de comptine calme.",
    leave: "Sortir",
  },
  offer: {
    forParents: "Pour les grands",
    banner: "🎄 L'histoire « Bini et l'étoile de Noël » offerte avec le Pack Comptines",
  },
  coloring: {
    title: "Coloriages",
    all: "Tous",
    download: "Télécharger",
    free: "Gratuit",
    packs: "Packs de coloriages",
    packsHint: "Pour les grands : à acheter dans l'Espace parents.",
    askAdult: "Demander à un adulte",
    empty: "Les coloriages arrivent bientôt !",
  },
  legal: {
    mentions: "Mentions légales",
    privacy: "Confidentialité",
    cgv: "CGV",
    updated: "Mise à jour le {date}",
  },
  shop: {
    title: "Packs de coloriages",
    adultsOnly: "Achat réservé aux adultes. Paiement sécurisé par Stripe.",
    buy: "Acheter",
    empty: "Aucun pack pour le moment.",
    redirecting: "Redirection vers le paiement…",
    checking: "Vérification du paiement…",
    success: "Merci ! Votre pack est prêt.",
    thanks: "Merci pour votre achat !",
    processing: "Votre paiement est en cours de confirmation par votre banque. Dès qu'il sera confirmé, vous recevrez vos coloriages par e-mail.",
    downloadMine: "Télécharger mes coloriages",
    emailSent: "Le lien a aussi été envoyé à {email}.",
    resend: "Renvoyer l'e-mail",
    resent: "E-mail renvoyé à {email}",
    error: "Une erreur est survenue",
    checkingLink: "Je vérifie votre lien…",
    invalidLink: "Ce lien de téléchargement n'est pas valide.",
    lostLink: "J'ai perdu mon lien",
    lostTitle: "J'ai perdu mon lien",
    lostHint: "Indiquez l'adresse e-mail utilisée pour l'achat : si une commande payée existe, nous vous envoyons un nouveau lien valable 7 jours.",
    lostEmail: "Adresse e-mail de l'achat",
    lostSubmit: "Recevoir un nouveau lien",
    lostDone: "C'est noté ! Si une commande payée correspond à cette adresse, un e-mail vient de partir.",
    download: "Télécharger le PDF",
    downloadPack: "Télécharger : {title}",
    downloadBonus: "Télécharger le bonus : {title}",
    bonusHint: "Bonus de Noël, fichier PDF d'environ 15 Mo : le téléchargement peut prendre un peu de temps.",
    validUntil: "Lien valable jusqu'au {date}.",
    expired: "Ce lien de téléchargement a expiré. Demandez un nouveau lien ci-dessous.",
    failed: "Le paiement n'a pas pu être confirmé.",
    cancel: "Paiement annulé. Aucun montant n'a été débité.",
    back: "Retour à l'Espace parents",
  },
  newsletter: {
    title: "Newsletter",
    hint: "Les nouvelles comptines et coloriages, de temps en temps.",
    email: "Votre adresse e-mail",
    consent: "J'accepte de recevoir la newsletter MIZUBINI par e-mail. Je peux me désinscrire à tout moment.",
    submit: "S'inscrire",
    done: "Merci, votre inscription est enregistrée !",
    unsubTitle: "Désinscription",
    unsubDo: "Me désinscrire",
    unsubDone: "Vous êtes désinscrit(e). Vous ne recevrez plus la newsletter.",
    unsubInvalid: "Ce lien de désinscription n'est pas valide.",
  },
  contact: {
    title: "Contact",
    name: "Votre nom",
    email: "Votre e-mail",
    message: "Votre message",
    submit: "Envoyer",
    done: "Merci, votre message est bien envoyé !",
    note: "Vos coordonnées servent uniquement à vous répondre.",
  },
  stars: {
    found: "Bravo ! Une étoile pour le ciel de Bini !",
    hiddenLabel: "Une petite étoile",
    skyTitle: "Le ciel de Bini",
    skyEmpty: "Des petites étoiles se cachent dans le site. Si tu en trouves, elles viendront ici !",
    skySome: "Merci ! Mon ciel brille de plus en plus.",
    skyFull: "Toutes les étoiles sont là. Mon ciel est magnifique, merci !",
    party: "Hourra ! Mon ciel est tout rempli d'étoiles !",
    partyAgain: "Faire la fête avec Bini",
  },
  parents: {
    gateTitle: "Pour les grands",
    gateHint: "Résolvez ce petit calcul pour entrer.",
    answer: "Votre réponse",
    enter: "Entrer",
    wrong: "Ce n'est pas la bonne réponse, voici un autre calcul.",
    starsInfo: "Étoiles trouvées sur cet appareil : {n} sur {total}.",
    privacy: "La progression est enregistrée uniquement sur cet appareil, sans compte ni donnée personnelle.",
    reset: "Remettre à zéro",
    resetConfirmTitle: "Remettre le ciel de Bini à zéro ?",
    resetConfirmText: "Toutes les étoiles trouvées sur cet appareil seront effacées.",
    resetDone: "Le ciel de Bini est remis à zéro.",
    cancel: "Annuler",
    soonIntro: "D'autres choses arrivent bientôt ici :",
    soon: "bientôt",
    newsletter: "Newsletter",
    packs: "Packs de coloriages",
    contact: "Contact",
  },
  soon: {
    coloring: "Les coloriages arrivent bientôt !",
    parents: "L'espace parents arrive bientôt !",
    notFound: "Oups ! Cette page s'est envolée.",
    home: "Retour à l'accueil",
  },
};

export default fr;
